import { createSlice } from "@reduxjs/toolkit";


export const formulesSlice = createSlice({
    name: 'formules',
    initialState:{},
    reducers: { // 
       
        initFormules: (currentState, action) => {
           
            let newList = [].concat(action.payload);
            return newList;

        },
        
       
    }
});

